import { Grid, Button } from "@mui/material";
import { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { H4 } from "../../components/Typography";
import { load, remove } from "../../constants/storage";

const AssistedPaymentCompete: FC = () => {
  let navigate = useNavigate();
  let userDetail: any = load("userData");
  let userDetails = JSON.parse(userDetail);
  console.log("----useuserData", userDetails);

  const closeWindow = () => {
    window.close();
  };

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <H4
        fontSize={22}
        fontWeight="600"
        sx={{ fontFamily: "'Poppins', sans-serif" }}
      >
        Your payment is complete
      </H4>
      <H4 fontWeight="400" sx={{ fontFamily: "'Poppins', sans-serif" }}>
        Please close this tab
      </H4>
      <Button
        onClick={() => closeWindow()}
        disableElevation
        disableRipple
        size="medium"
        sx={{
          background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
          color: "#fff",
          width: {
            md: "30%",
            xs: "70%",
          },
          mb: 1,
          mt: { xs: 3, sm: 6.5, md: 6.5 },
          textTransform: "none",
        }}
      >
        Close
      </Button>
    </Grid>
  );
};

export default AssistedPaymentCompete;
